import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DESTINATION_IMAGES } from "@/lib/media";

export default function DestinationCard({ destination, span = "default" }) {
  const img = DESTINATION_IMAGES[destination.slug];
  const spanCls =
    span === "tall"
      ? "md:row-span-2"
      : span === "wide"
      ? "md:col-span-2"
      : "";

  return (
    <Link
      to={`/destinations/${destination.slug}`}
      data-testid={`destination-card-${destination.slug}`}
      className={`group relative overflow-hidden block ${spanCls}`}
      style={{ minHeight: span === "tall" ? 480 : 240 }}
    >
      <img
        src={img}
        alt={`${destination.name} — Trawelldmc DMC ${destination.country}`}
        width="1200"
        height="800"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(11,25,44,0.1) 0%, rgba(11,25,44,0.75) 100%)",
        }}
      />
      <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-between text-white">
        <div className="overline !text-white/80">{destination.country}</div>
        <div>
          <div className="font-heading text-3xl md:text-4xl font-light tracking-tight mb-2">
            {destination.name}
          </div>
          <div className="text-sm text-white/80 max-w-xs">{destination.tagline}</div>
          <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#FF5238] group-hover:gap-3 transition-all">
            Explore packages <ArrowUpRight className="h-4 w-4" />
          </div>
        </div>
      </div>
    </Link>
  );
}
